import { BasicInput, Row } from '@elotech/components';
import { FormikProps } from 'formik';
import React from 'react';

import { useCamposLocalizacao } from '../../hooks/useCamposLocalizacao';
import { Laudo } from '../../type';
import { CampoLocalizacao } from '../../utils/InscricaoCadastralUtils';

type Props = {
  formProps: FormikProps<Laudo>;
  /** Campos de localização já carregados pela tela; sem eles, o componente carrega a configuração. */
  camposLocalizacao?: CampoLocalizacao[];
};

const PropriedadeFormUrbano: React.FC<Props> = props => {
  const { formProps } = props;
  const camposLocalizacao = useCamposLocalizacao(props.camposLocalizacao);

  return (
    <>
      <Row>
        <BasicInput
          size={3}
          name={'cadastroImobiliario.proprietario'}
          label={'Proprietário'}
          disabled
        />
        <BasicInput
          size={3}
          name={'cadastroImobiliario.inscricaoCadastral'}
          label={'Inscrição Cadastral'}
          disabled
        />
        <BasicInput
          size={2}
          name={'cadastroImobiliario.areaTerreno'}
          label={'Área Terreno'}
          disabled
        />
        <BasicInput
          size={2}
          name={'cadastroImobiliario.areaConstruida'}
          label={'Área Construída'}
          disabled
        />
      </Row>
      <Row>
        {camposLocalizacao.map(({ campo, label, campoCadastro }) => (
          <BasicInput
            key={campo}
            size={2}
            name={`cadastroImobiliario.${campoCadastro}`}
            label={label}
            disabled
          />
        ))}
        <BasicInput
          size={12}
          name={'cadastroImobiliario.complementoLote'}
          label={'Complemento Lote'}
          disabled
        />
      </Row>
      <Row>
        <BasicInput
          size={2}
          name={'cadastroImobiliario.cep'}
          label={'CEP'}
          disabled
        />
        <BasicInput
          size={10}
          name={'cadastroImobiliario.endereco'}
          label={'Endereço'}
          disabled
        />
        <BasicInput
          size={1}
          name={'cadastroImobiliario.numero'}
          label={'Número'}
          disabled
        />
        <BasicInput
          size={5}
          name={'cadastroImobiliario.complemento'}
          label={'Complemento'}
          disabled
        />
        <BasicInput
          size={2}
          name={'cadastroImobiliario.cidade'}
          label={'Cidade'}
          disabled
        />
        <BasicInput
          size={4}
          name={'cadastroImobiliario.estado'}
          label={'Estado'}
          disabled
        />
        <div className="form-group col-md-12">
          <label htmlFor="condominioInput">Condomínio</label>
          <input
            id="condominioInput"
            type="text"
            name="cadastroImobiliario.condominio"
            value={
              formProps.values.cadastroImobiliario?.condominio
                ? `${formProps.values.cadastroImobiliario?.condominio} - ${formProps.values.cadastroImobiliario?.descricaoCondominio}`
                : ''
            }
            disabled={true}
          />
        </div>
      </Row>
    </>
  );
};

export default PropriedadeFormUrbano;
